
import React from 'react';


import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import AbstractForceMuteRemoteparticipantDialog, { _mapStateToProps }
    from '../AbstractForceMuteRemoteparticipantDialog';

/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before muting a remote participant.
 *
 * @augments Component
 */
class ForceMuteDialog extends AbstractForceMuteRemoteparticipantDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const audios = this.props._lockAudio;
        const { participantID } = this.props;

        return (
            <Dialog
                okKey = { audios[`${participantID}`] ? this.props.t('dialog.unforceMuteParticipantBody')
                    : this.props.t('dialog.forceMuteParticipantButton') }
                onSubmit = { this._onSubmit }
                titleKey = 'dialog.forceMuteParticipantTitle'
                width = 'small'>
                <div>
                    { audios[`${participantID}`] ? this.props.t('dialog.unforceMuteParticipantBody')
                        : this.props.t('dialog.forceMuteParticipantBody') }
                </div>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
}

export default translate(connect(_mapStateToProps)(ForceMuteDialog));
